<template>
  <div class="content-5num" :class="{ 'stars-widget': isWidget && (question.stars && question.stars.active) }">
    <div class="image-container" v-if="question.type === 'csat' && question.showImageOnTitle && this.question.imagePosition === 'middle' && !preview">
      <ImageWrapper
        :uploaderId="`5num-uploader`"
        :uploaderTitle="$t('sendhub.set_image_text')"
        :imageProps="imagePropsDefault(question)"
        :canDelete="false"
        :disableMenus="false"
        :menuOptions="[]"
        @resetAutoStartUpload="handleResetAutoStartUpload"
        @submenu-action="handleImageAction"
        class="num5-image-wrapper"
      />
    </div>
    <app-form-rate
      v-model="inputValue"
      :isStar="(question.stars && question.stars.active)"
      :useStarNumbers="(question.stars && question.stars.numbers)"
      :items="items"
      item-value="id"
      item-text="id"
      :isGradient="question.gradient"
      :textColor="colors.actionText"
      :bgColor="colors.actionColor"
      :hoverColor="colors.buttonHover"
      :labelColor="colors.splashColor"
      :max-label="question.type === 'csat' && question.showImageOnTitle && question.hideAllSubjectLabels ? '' : t(false)"
      :min-label="question.type === 'csat' && question.showImageOnTitle && question.hideAllSubjectLabels ? '' : t(true)"
    />
  </div>
</template>

<script>
import { translator, gradientMaker } from '@/_helpers'
import ImageWrapper from '@/components/survey/ImageWrapper.vue'

export default {
  name: 'app5num',
  props: ['response', 'preview', 'question', 'colors', 'isWidget'],
  components: {
    'app-form-rate': () => import('@binds-tech/binds-design-system/src/components/Form/Rate'),
    ImageWrapper
  },
  data () {
    return {
      inputValue: null,
      items: [
        { id: 1 },
        { id: 2 },
        { id: 3 },
        { id: 4 },
        { id: 5 }
      ]
    }
  },
  created () {
    gradientMaker.checkGradientAndReturnTheColors(this.question, this.items)

    this.$root.$on('language-update', (language, id) => {
      if (this.question.id === id) {
        this.question.startLabel = translator.translateThisText(language, 'components.csat_not_satisfied')
        this.question.endLabel = translator.translateThisText(language, 'components.csat_satisfied')
      }
    })

    if (this.question.startLabel === '' && this.question.endLabel === '') {
      this.question.startLabel = translator.translateThisText(this.question.language, 'components.csat_not_satisfied')
      this.question.endLabel = translator.translateThisText(this.question.language, 'components.csat_satisfied')
    }

    if (this.question.showImageOnTitle) {
      this.getOrCreateImageForTitle()
    }
  },
  methods: {
    t (isStart) {
      // Não remover segunda parte da condição. Foi feita para lidar com pesquisas vindas da v1.
      if ((this.question.stars && !this.question.stars.active) && (!this.question.startLabel && !this.question.endLabel)) {
        this.question.startLabel = translator.translateThisText(this.question.language, 'components.csat_not_satisfied')
        this.question.endLabel = translator.translateThisText(this.question.language, 'components.csat_satisfied')
      }

      if (isStart) {
        return this.question.startLabel
      }

      return this.question.endLabel
    },
    imagePropsDefault (question) {
      const imageOnTitle = this.getOrCreateImageForTitle()

      return {
        id: question.id,
        success: Boolean(imageOnTitle.label),
        where: 'imageOnTitle',
        autoStartUpload: imageOnTitle?.autoStartUpload,
        label: imageOnTitle?.label,
        imageIndex: 0 // Always use index 0
      }
    },
    getOrCreateImageForTitle () {
      if (!this.question.imageOnTitle) {
        this.$set(this.question, 'imageOnTitle', [])
      }

      if (!this.question.imageOnTitle[0]) {
        const defaultImage = {
          label: 'https://img.binds.co/437e8dd8-82df-4a39-a30c-43ee8f8a6eea/-/crop/255x237/18,18/-/preview/',
          isHidden: false,
          value: 'imagem 1',
          imageSize: '',
          autoStartUpload: false
        }
        this.$set(this.question.imageOnTitle, 0, defaultImage)
        this.$store.commit('survey/upsertQuestion', { ...this.question })
      }

      return this.question.imageOnTitle[0]
    },
    handleResetAutoStartUpload () {
      if (this.question.imageOnTitle?.[0]) {
        this.question.imageOnTitle[0].autoStartUpload = false
        this.$store.commit('survey/upsertQuestion', { ...this.question })
      }
    },
    handleImageAction (action) {
      if (action === 'toggle-visibility') {
        const imageOnTitle = this.question.imageOnTitle[0]
        if (imageOnTitle) {
          this.$set(imageOnTitle, 'isHidden', !imageOnTitle.isHidden)
          this.$store.commit('survey/upsertQuestion', { ...this.question })
        }
      }
    }
  }
}
</script>
<style lang="scss">
.content-5num {
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  .image-container {
    width: 200px;
    height: 200px;
    margin-bottom: 15px;

    .num5-image-wrapper {
      width: 100%;
      height: 100%;
      :deep(.image-wrapper-component) {
        aspect-ratio: 1;
      }
    }
  }

  & .star-span {
    top: 20.6px !important;
  }
}
.stars-widget {
  margin-left: -32px !important;
  margin-bottom: 32px;
}
</style>
